import React from 'react';
import { footer } from '../data/content';
import { siteConfig } from '../data/siteConfig';
import { getFooterLinks } from '../utils/siteLinks';
export function Footer() {
  const links = getFooterLinks();
  return <footer className="w-full border-t border-ivory/10 bg-forest-dark px-5 pb-28 pt-12 text-center md:px-8 md:pb-14" data-id="element-90" data-mp="32ovukn0cqfgg">
      <div className="mx-auto w-full max-w-content" data-id="element-91" data-mp="36pza18ehm9h5">
        <p className="font-serif text-xl font-semibold text-ivory" data-id="element-92" data-mp="3ufa6wespvjq0">{siteConfig.productName}</p>
        <p className="mt-2 text-[15px] text-ivory/70" data-id="element-93" data-mp="38h3d4agb8ib">{footer.tagline}</p>

        {links.length > 0 && <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-94" data-mp="3levih6kghoia">
            {links.map(link => <li key={link.label} data-id="element-95" data-mp="3qc3zh3tvbmhy">
                <a href={link.href} className="inline-flex min-h-11 items-center text-[15px] font-medium text-ivory/75 transition-colors duration-150 ease-out hover:text-ivory" data-id="element-96" data-mp="3qf9q4ni5awfs">
                  {link.label}
                </a>
              </li>)}
          </ul>}
      </div>
    </footer>;
}